import React from 'react';
import AdsTable from './AdsTable';
import { useShellChrome } from './ShellChromeContext';

/**
 * ListReportTemplate — table panel for list/report pages (§7 table strategy).
 * Use inside ListPageTemplate `content` (or any ads-screen-list region).
 * Wraps table markup in one ads-panel + optional header/pagination without
 * duplicating legacy `.table-container` wrappers.
 */
const ListReportTemplate = ({
  children,
  className = '',
  panelClassName = '',
  headerClassName = '',
  header,
  title,
  titleCount,
  headerActions,
  paginationTop,
  paginationBottom,
  footer,
  suppressSectionTitle,
  stickyFirst = true,
  /** Pin thead inside a bounded table scroll region (ERP registries). */
  stickyHead = true,
  wrapTable = true,
  tableClassName = '',
  containerClassName = '',
}) => {
  const { titleOwned } = useShellChrome();
  const compactTitle = suppressSectionTitle ?? titleOwned;
  const resolvedTableClassName = [
    stickyFirst ? 'ads-table--sticky-first' : '',
    tableClassName,
  ]
    .filter(Boolean)
    .join(' ');
  const resolvedContainerClassName = [
    stickyHead ? 'table-container--sticky-head' : '',
    containerClassName,
  ]
    .filter(Boolean)
    .join(' ');

  const tableBody = wrapTable ? (
    <AdsTable
      tableClassName={resolvedTableClassName || undefined}
      containerClassName={resolvedContainerClassName || undefined}
    >
      {children}
    </AdsTable>
  ) : (
    children
  );

  const showHeader = Boolean(header || title);

  return (
    <div
      className={[
        'ads-panel',
        'ads-screen-list__table',
        compactTitle ? 'ads-list-report--compact-title' : '',
        panelClassName,
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {showHeader ? (
        <div className={['ads-panel__header', headerClassName].filter(Boolean).join(' ')}>
          {header ?? (
            <div className="ads-list-report__header-row">
              {title ? (
                <h3 className="ads-type-section">
                  {title}
                  {titleCount != null ? (
                    <span className="ads-list-report__count">{titleCount}</span>
                  ) : null}
                </h3>
              ) : null}
              {headerActions ? (
                <div className="ads-list-report__header-actions">{headerActions}</div>
              ) : null}
            </div>
          )}
        </div>
      ) : null}

      {paginationTop}
      {tableBody}
      {paginationBottom}
      {footer}
    </div>
  );
};

export default ListReportTemplate;
